import { createTheme } from "@mui/material/styles";

/** Dark palette for video editor modals (export, format) — matches timeline UI. */
export const editorModalTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#38bdf8",
      dark: "#0ea5e9",
      light: "#7dd3fc",
      contrastText: "#0f172a",
    },
    background: {
      default: "#0f172a",
      paper: "#1e293b",
    },
    text: {
      primary: "#f1f5f9",
      secondary: "#94a3b8",
    },
    divider: "rgba(148, 163, 184, 0.22)",
  },
  shape: {
    borderRadius: 8,
  },
});
